import React, { memo } from 'react';
import Container from 'Nori/Container/index';
import styles from 'Custom/Pregnancies/index.module.scss';
import {
  DEFAULT_CONTENT,
  DEFAULT_HEADLINE,
  DEFAULT_FOOTER_TEXT,
  BLOCK_DESCRIPTION,
  BLOCK_DESCRIPTION_BIRTH_CONTROL,
} from './utils';
import RichText from 'Custom/RichText/index';

const Pregnancies = ({
  headerp = { ...DEFAULT_HEADLINE },
  footerp = DEFAULT_FOOTER_TEXT,
  content = DEFAULT_CONTENT,
  className = '',
  copy = BLOCK_DESCRIPTION,
  children,
  ...props
}) => {
  return (
    <section className={`${styles.wrapper} ${className}`} {...props}>
      <Container className={styles.container} data-qa-tag="container-main">
        <RichText
          className={styles.copyBlock}
          data-qa-tag="richtext-copy-block"
        >
          <h2 data-qa-tag="heading-copy-title">{copy.title}</h2>
          <p className="intro" data-qa-tag="paragraph-copy-content">
            {copy.content}
          </p>
        </RichText>

        <RichText
          className={styles.graphic}
          data-qa-tag="richtext-graphic-section"
        >
          <div className={styles.graphicHead} data-qa-tag="graphic-header">
            <p className={styles.title} data-qa-tag="graphic-header-title">
              {headerp.title}
            </p>
            <p
              className={styles.subtitle}
              data-qa-tag="graphic-header-subtitle"
            >
              {headerp.subtitle}
            </p>
          </div>

          <div className={styles.graphicBody} data-qa-tag="graphic-body">
            <div className={styles.arrowWrapper} data-qa-tag="arrow-wrapper">
              <div className={styles.arrowImage} data-qa-tag="arrow-image" />
            </div>

            <div className={styles.bodyWrapper} data-qa-tag="body-wrapper">
              {content.map((item, index) => (
                <div
                  className={styles.graphicRow}
                  key={`g-row-${index}`}
                  data-qa-tag={`graphic-row-${index}`}
                >
                  {item.title && (
                    <div
                      className={styles.bodyTitle}
                      data-qa-tag={`body-title-${index}`}
                    >
                      <p data-qa-tag={`body-title-text-${index}`}>
                        {item.title}
                      </p>
                    </div>
                  )}

                  <div
                    className={styles.bodyBlocks}
                    data-qa-tag={`body-blocks-${index}`}
                  >
                    {item.list &&
                      item.list.map((itemList, indexSubList) => (
                        <div
                          className={styles.bodyChildBlock}
                          key={`item-list-${indexSubList}`}
                          data-qa-tag={`body-child-block-${index}-${indexSubList}`}
                        >
                          {itemList['0'].items &&
                            itemList['0'].items.map((itemlist, indexList) => (
                              <ul
                                className={styles.list}
                                key={`list-${indexList}`}
                                data-qa-tag={`list-${index}-${indexSubList}-${indexList}`}
                              >
                                {itemlist &&
                                  itemlist.map(
                                    (nesteditem, indexNestedList) => (
                                      <li
                                        key={`nested-${indexNestedList}`}
                                        data-qa-tag={`list-item-${index}-${indexSubList}-${indexList}-${indexNestedList}`}
                                      >
                                        {nesteditem}
                                      </li>
                                    )
                                  )}
                              </ul>
                            ))}
                        </div>
                      ))}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className={`${styles.graphicHead} ${styles.graphicHead2}`} data-qa-tag="graphic-footer">
            <p className={styles.title} data-qa-tag="graphic-footer-title">
              {footerp}
            </p>
          </div>
        </RichText>
      </Container>
    </section>
  );
};

const MemoPregnancies = memo(Pregnancies);

export { MemoPregnancies as Pregnancies };
